import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Sdk from 'api.digitalpages.module.sdk.api';
import Offliner from './hooks/offliner';

import "core-js/stable";
import "regenerator-runtime/runtime";
import {getProjectUidByHost} from "./services/config";

function start() {
  if (localStorage.getItem("iammobile") == "true") {
    document.addEventListener("deviceready", function () {
      //listenAppEvents();
      setup()
    });
  } else {
    setup()
  }
}

// const listenAppEvents = async () => {
//   var cordovaInstance = window.CordovaExec;

//   ///progresso de download
//   cordovaInstance(
//     function (response) {
//       console.log("RegisterDownloadChanges", response);

//     },
//     "UnifiedApiPlugin",n
//     "Process",
//     [{ name: "RegisterDownloadChanges" }]
//   );
// };

async function setupSdk() {
  try {
    // Carregar configurações em paralelo
    const configPromise = fetch("./api_context.json").then(r => r.json());
    
    // Verificar credenciais existentes
    let authLocal = null;
    for (let i = 0, len = window.localStorage.length; i < len; ++i) {
      if (window.localStorage.key(i).search("authorization-project-") > -1) {
        authLocal = localStorage.key(i);
        break;
      }
    }

    // Processar autenticação existente
    if (authLocal) {
      const obj = JSON.parse(window.localStorage.getItem(authLocal));
      const timestampInMiliseconds = new Date().getTime();
      const formattedTimestamp = timestampInMiliseconds / 1000;
      
      if (obj.credential && formattedTimestamp > obj.credential.expire) {
        window.localStorage.removeItem(authLocal);
        window.localStorage.removeItem("authorization-key-e3894d14dbb743d78a7efc5819edc52e-production'");
      }
    }

    // Aguardar configurações e configurar SDK
    const config = await configPromise;
    
    Sdk.setProjectKey(config.project_key);
    Sdk.setEnviroment(config.api_env);
    Sdk.authorization.shareSession = true;

    if (config.domain) {
      const domain = `${window.location.protocol}//` + config.domain;
      Sdk.Api.domain = domain;
      
      // Configurar todos os domínios de uma vez
      const services = [
        'authorization', 'directRegister', 'storage', 'store',
        'insights', 'cms', 'iot', 'dynamic', 'dam', 'guide'
      ];
      
      services.forEach(service => {
        if (Sdk.Api[service]) Sdk.Api[service].domain = domain;
      });
    }

    return config.project_uid;
  } catch (error) {
    console.error('Error setting up SDK:', error);
    return null;
  }
}

function setup() {
  Sdk.Api.request.Request.onMobile = Offliner.inApp();
  Sdk.Api.request.Request.handleError = async function(response) {
    if (response && response.status) {
      const { credential } = Sdk.Api.authorization;

      let currentTimestamp = new Date().getTime()/1000;
      if (credential && !/(2)[0-9][0-9]/g.test(response.status) && credential.expire && currentTimestamp > credential.expire) {
        window.dispatchEvent(new Event("@rdpplayer.event(logout)"));
      }
    }
  };
  ReactDOM.render(<App/>, document.getElementById('root'));
}

const setActiveProject = async (apiContext) => {
  try {
    // var config = await getProjectUidByHost();

    const projectHostConfig = await getProjectUidByHost();
    let projectUid = null;

    if (projectHostConfig) {
      projectUid = projectHostConfig.project_uid;
    } else {
      const response = await fetch("./api_context.json");
      const config = await response.json();
      projectUid = config.project_uid;
    }

    try {
      var projectByDomainRequest = await fetch(`${Sdk.Api.domain}/auth/v1.0/project/domain/${window.location.host}`, {
        "headers": {
          "api-env": Sdk.Api.enviroment,
          "project-key": Sdk.Api.projectKey,
        },
        "method": "GET"
      });
      var projectByDomainResponse = await projectByDomainRequest.json();

      projectUid = projectByDomainResponse.uid;
    } catch (e) {
      console.log(e)
    }

    const projectResp = await fetch(`${Sdk.Api.domain}/auth/v1.0/project/uid/${projectUid}`, {
			"headers": {
				"api-env": Sdk.Api.enviroment,
				"project-key": Sdk.Api.projectKey,
			},
			"method": "GET"
		});
    const project = await projectResp.json();
    await Sdk.initializeFromProject(projectUid, "DirectRegister_1");
    Sdk.authorization.setActiveProject(project);
    Sdk.authorization.activeProjectUid = projectUid;
  } catch (e) {
    console.error(e)
  }
}

async function preStart() {
  var authLocal = null;
  for (var i = 0, len = window.localStorage.length; i < len; ++i ) {
    if (window.localStorage.key(i).search("authorization-project-") > -1) {
      authLocal = localStorage.key(i);
    };
  };
  if (authLocal) {
    var obj = JSON.parse(window.localStorage.getItem(authLocal));
    var timestampInMiliseconds = new Date().getTime()
    var formattedTimestamp = timestampInMiliseconds / 1000;
    if (obj.credential) {
      if (formattedTimestamp > obj.credential.expire) {
        window.localStorage.removeItem(authLocal);
        window.localStorage.removeItem("authorization-key-e3894d14dbb743d78a7efc5819edc52e-production'");
      }
    }
  };

  const response = await fetch("./api_context.json");
  const config = await response.json();
  // console.log(config)
  Sdk.setProjectKey(config.project_key);
  Sdk.setEnviroment(config.api_env);
  Sdk.authorization.shareSession = true;

  if (config.domain != undefined) {
    Sdk.Api.domain = `${window.location.protocol}//` + config.domain;
    //todo:corrigir sdk
    Sdk.Api.authorization.domain = Sdk.Api.domain;
    Sdk.Api.directRegister.domain = Sdk.Api.domain;
    Sdk.Api.storage.domain = Sdk.Api.domain;
    Sdk.Api.store.domain = Sdk.Api.domain;
    Sdk.Api.insights.domain = Sdk.Api.domain;
    Sdk.Api.cms.domain = Sdk.Api.domain;
    Sdk.Api.iot.domain = Sdk.Api.domain;
    Sdk.Api.dynamic.domain = Sdk.Api.domain;
    Sdk.Api.dam.domain = Sdk.Api.domain;
    Sdk.Api.guide.domain = Sdk.Api.domain;
  }

  var projectUid = config.project_uid;

  try {
    var projectByDomainRequest = await fetch(`${Sdk.Api.domain}/auth/v1.0/project/domain/${window.location.host}`, {
      "headers": {
        "api-env": Sdk.Api.enviroment,
        "project-key": Sdk.Api.projectKey
      },
      "method": "GET"
    });

    try {
      var projectByDomainResponse = await projectByDomainRequest.json();

      projectUid = projectByDomainResponse.uid;
    } catch (err) {
      console.log(err);
    }

  } catch (e) {
    console.log(e);
  }


  if (projectUid !== "-") {
    try {
      await Sdk.initializeFromProject(projectUid, "Learning_1");
    } catch(e) {

    }
  };
  // await Sdk.initialize({"initializeConnectors": true}, "Learning_1");
  setActiveProject(config);
  start();
}

function onResume() {
  window.dispatchEvent(new Event("@rdpplayer.event(resume.background)"))
}

function startMobile() {
  preStart()
  // TODO: Ativar para usar modo offline
  // Sdk.Api.request.Request.onMobile = true;
  document.addEventListener('resume', onResume, false);
}

//document.addEventListener('deviceready', startMobile, false);

if (["http:", "https:"].includes(window.location.protocol) || window.location.hostname === "localhost") {
  preStart();
}

serviceWorker.unregister();
